/**
 * User Navigation Component
 *
 * This component renders the user profile section in the sidebar footer, including:
 * - User avatar and information
 * - Dropdown menu with navigation options
 * - Theme selection
 * - Logout functionality
 */

import { useAuth } from '@/features/auth'
import { getUserProfilePicture } from '@/lib/auth-utils'
import { useNavigate } from 'react-router-dom'

import {
    Avatar,
    AvatarFallback,
    AvatarImage,
} from "@/components/ui/avatar"

/**
 * User navigation component for the sidebar footer
 * Displays user information and provides access to account settings and theme options
 */
export function NavUser() {
    const navigate = useNavigate();
    const { session } = useAuth();

    // Don't render anything if there's no user session
    if (!session?.user) {
        return null;
    }

    // Extract user information
    const user = session.user;
    const userInitials = user.email ? user.email.substring(0, 2).toUpperCase() : 'U';

    return (
        <button 
            onClick={() => navigate('/account')}
            className="rounded-full hover:opacity-80 transition-opacity focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
        >
            <Avatar className="h-8 w-8 rounded-full cursor-pointer">
                <AvatarImage src={getUserProfilePicture(user) || undefined} alt={user.email || ''} />
                <AvatarFallback className="rounded-full bg-primary/10 text-primary border border-primary/20 cursor-pointer">{userInitials}</AvatarFallback>
            </Avatar>
        </button>
    )
}
